export default __webpack_public_path__ + "static/media/retirement.38267b42.jpg";